import { makeVar } from "@apollo/client";

export const assessmentContextSidebarVar = makeVar<{
  assessmentId: number;
  questionId: number;
} | null>(null);
